<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="22" viewBox="0 0 38 22" fill="none">
        <path d="M4.01616 1C10.4994 9.74656 -7.14056 11.4468 6.01616 21.5" stroke="#C6C6C6"/>
        <path d="M19.5323 1C26.0156 9.74656 8.37558 11.4468 21.5323 21.5" stroke="#C6C6C6"/>
        <path d="M35.0484 1C41.5317 9.74656 23.8917 11.4468 37.0484 21.5" stroke="#C6C6C6"/>
      </svg>
</template>
